import axios from 'axios';
import React, { Component } from "react";
import { FaTrash } from 'react-icons/fa';
import XLSX from 'xlsx';
import { make_cols } from '../screens/MakeColumns';
import 'date-fns';
import Loader from 'react-loader-spinner';
import moment from 'moment';
import '../App.css'

import {
  Input,
  createMuiTheme,
  MuiThemeProvider,
  Button,
} from "@material-ui/core";
import { withStyles, } from "@material-ui/core";

import { generateData, seatSectionKeys, seatSection } from '../services/userServices'
import TopBar from "./TopBar";

import { getAssetsInfo ,generateTeamData} from '../services/userServices'

const theme = createMuiTheme({
  overrides: {
    MuiChip: {
      root: {
        fontSize: "11px",
        color: "#3c4043",
        marginTop: 20,
        height: 25,
        backgroundColor: "rgba(0, 0, 0, 0.10)",
        padding: "3px 5px"
      },
      deleteIcon: {
        width: 14,
        height: 14,
        margin: 0
      },
      label: {
        color: "#3c4043",
        cursor: "pointer",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "11px",
        margin: "0 6px",
        padding: "1px",
        paddingLeft: 0,
        paddingRight: 0,
        marginRight: 0,
        fontWeight: 600
      }
    }
  },
  typography: {
    useNextVariants: true
  },

});

class dataGenerate extends Component {
  constructor() {
    super();

    this.state = {
      openNote: false,
      eventName: '',
      stadiumLoc: '',
      time_zone: "",
      eventDate: new Date(),
      eventendDate: new Date(),
      eventTime: moment(new Date(), [moment.ISO_8601, 'HH:mm']),
      endTime: moment(new Date(new Date().setMinutes(new Date().getMinutes() + 1)), [moment.ISO_8601, 'HH:mm']),
      newData: {},

      team1LogoName: '',
      date: "",
      currentDate: "",
      //eventPhoto: '',
      statdiumImage: '',
      team1Name: '',
      team1Logo: '',
      team1Hex1: 'FFFFFF',
      team1Hex2: 'FFFFFF',
      fileName: '',
      Sfiles: {},
      team2Name: '',
      image1Checked: true,
      image2Checked: true,
      image3Checked: true,
      fileChecked: true,
      image1Message: '',
      image2Message: '',
      fileMessage: '',
      image3Message: '',
      checkDisabled: false,
      dataResponse: {},
      teamName: '',
      teamLogo: '',
      teamHex1: 'FFFFFF',
      teamHex2: 'FFFFFF',
      cols: [],
      loading: false,
      newDate: {}
    }



    this.onCreated = this.onCreated.bind(this);

    this.handleFile = this.handleFile.bind(this);
    this.handleChange = this.handleChange.bind(this);


  }

  onCreated() {
    const cpElem = this.colorPicker.element.nextElementSibling;
    cpElem.insertBefore(this.colorPicker.element, cpElem.children[2]);
    // console.log('====================================', cpElem.insertBefore(this.colorPicker.element, cpElem.children[2]))
    // console.log("VALUE IS ", cpElem)
    // console.log('====================================')
  }

  /******************************************************************** */


  handleteam1Name = evt => {
    try {
      this.setState({
        team1Name: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team A Name in dataGenearation");

    }
  }


  handleteam1Logo = evt => {
    try {
      this.setState({
        team1Logo: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team B LOGO in dataGenearation");
    }
  }


  /********************************************************************************** */

  /**********current date************* */

  componentDidMount() {
    this.getDate();
  }

  getDate = () => {
    var date = new Date().toDateString();
    this.setState({ date });
  };

  /***************************************** */

  handleChange(date) {
    this.setState({
      startDate: date
    });
  }

  /*******************time and date******************************** */

  componentWillMount = () => {
    const date = new Date();
    const dateAndTime = date.toISOString().split("T");
    const time = dateAndTime[1].split(":");
    const final = dateAndTime[0] + "T" + time[0] + ":" + time[1];
    this.setState({
      currentDate: final
    });
  };


  removeAsset = () => {
    this.state.checkDisabled = true
    this.setState({
      team1LogoName: ''
    })
    document.getElementById("team1").value = ""
  }



  getName = evt => {
   

    if (document.querySelector('input[id=team1]').files[0]) {
      this.state.checkDisabled = false
      this.setState({
        team1LogoName: document.querySelector('input[id=team1]').files[0].name
      })
      if (document.querySelector('input[id=team1]').files[0].type == "image/jpeg" ||
        document.querySelector('input[id=team1]').files[0].type == "image/png" ||
        document.querySelector('input[id=team1]').files[0].type == "image/svg+xml") {
        if (document.querySelector('input[id=team1]').files[0].size >= 5000000) {
          this.state.image3Checked = false
          this.state.image3Message = 'Image should be less than 5 MB in size.'
        } else {
          this.state.image3Checked = true
          this.checkDisabled()
        }
      }
      else {
        this.state.image3Checked = false
        this.state.image3Message = 'Only Images are accepted'
        this.checkDisabled()
      }
    }
  }
  checkDisabled() {
    this.state.checkDisabled = false
    if (this.state.image2Checked && this.state.image3Checked && this.state.fileChecked) {
      this.state.checkDisabled = false
    }
  }
  handleChange = date => event => {
    this.setState({ [date]: new Date(event.target.value).toLocaleString() });
  };
  sendDate = event => {
    event.preventDefault();
    this.props.ShowNotification("Note Status: ", "Reminder set", "success");
    this.props.reminder(this.state.date, this.props.noteID);
    this.handleClose();
  };
  checkFile(e) {
    // alert(e.target.files[0].type)
    if (e.target.files[0] && e.target.files[0].type == "application/vnd.oasis.opendocument.spreadsheet") {
      if (e.target.files[0].size >= 5000000) {
        this.state.fileChecked = false
        this.state.fileMessage = 'File should be less than 5 MB'
      } else {
        this.handleFile()
        this.state.fileChecked = true
      }
    }
    else {
      this.state.fileChecked = false
      this.state.fileMessage = 'Only ods files are accepted'
      // console.log(this.state.fileChecked)
    }
  }
  checkImage1(e) {
    // alert(e.target.files[0].type)
    if (e.target.files[0].type == "image/jpeg" || e.target.files[0].type == "image/png") {
      if (e.target.files[0].size >= 5000000) {
        this.state.fileChecked = false
        this.state.fileMessage = 'File should be less than 5 MB'
      } else {
        this.handleFile()
        this.state.fileChecked = true
      }
    }
    else {
      this.state.fileChecked = false
      this.state.fileMessage = 'Only ods files are accepted'
      console.log(this.state.fileChecked)
    }
  }
  checkImage2(e) {
    // alert(e.target.files[0].type)
    if (e.target.files[0].type == "image/jpeg" || e.target.files[0].type == "image/png") {
      if (e.target.files[0].size >= 5000000) {
        this.state.fileChecked = false
        this.state.fileMessage = 'File should be less than 5 MB'
      } else {
        this.handleFile()
        this.state.fileChecked = true
      }
    }
    else {
      this.state.fileChecked = false
      this.state.fileMessage = 'Only ods files are accepted'
      // console.log(this.state.fileChecked)
    }
  }
  checkImage3(e) {
    // alert(e.target.files[0].type)
    if (e.target.files[0].type == "image/jpeg" || e.target.files[0].type == "image/png") {
      if (e.target.files[0].size >= 5000000) {
        this.state.fileChecked = false
        this.state.fileMessage = 'File should be less than 5 MB'
      } else {
        this.handleFile()
        this.state.fileChecked = true
      }
    }
    else {
      this.state.fileChecked = false
      this.state.fileMessage = 'Only ods files are accepted'
      // console.log(this.state.fileChecked)
    }
  }

  handleFile = () => {
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
      /* Get first worksheet */

      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      if (Object.entries(ws).length == 0) {
        this.state.fileChecked = false
        this.state.fileMessage = 'Empty file cannot be accepted'
        this.checkDisabled()
      }
      else {
        this.state.fileChecked = true
        /* Convert array of arrays */
        const Fdata = XLSX.utils.sheet_to_json(ws);
        let myCommaField = [];
        let mycolor = [];
        Fdata.forEach(element => {
          myCommaField.push(Object.entries(element).flat())
          for (var i = 0; i < myCommaField[0].length; i++) {
            if (myCommaField[0][i].includes(",")) {
              mycolor.push(myCommaField[0][i]);
            }
          }
          myCommaField = [];
        })
        var filteredArray = mycolor.filter(function (item, pos) {
          return mycolor.indexOf(item) == pos;
        });
        this.setState({
          team1Hex1: filteredArray[0].split(",")[0],
          team1Hex2: filteredArray[0].split(",")[1]
        })
        document.querySelector('input[id=TeamHex1').value = filteredArray[0].split(",")[0];
        document.querySelector('input[id=TeamHex2').value = filteredArray[0].split(",")[1];
        this.setState({ fileJSON: Fdata, cols: make_cols(ws['!ref']) }, () => {
          let seatsSectionKeys = [];
          Object.keys(this.state.fileJSON[0]).forEach(function (element) {
            if (element !== 'time' && element.startsWith("_") !== true && element.length > 4 !== true) {
              seatsSectionKeys.push(element);
            }
          });
          this.setState({
            SelectOptions: seatsSectionKeys.sort()
          })

          // seatSection(this.state.Fdata).then(res=>{
          //   console.log(res)
          // })
        });
        this.checkDisabled()
      }
    };
    if (rABS) {
      reader.readAsBinaryString(document.querySelector('input[id=file]').files[0]);

    } else {
      reader.readAsArrayBuffer(document.querySelector('input[id=file]').files[0]);

    };
  }
  /******************************************************************************** */

  handleToggle = (e) => {
    e.preventDefault();
    this.setState({ loading: true })
    try {
      this.setState({ openNote: !this.state.openNote });
     
        if (this.state.team1Name !== '' || this.state.team1LogoName !== '' ) {

          const data = {
            //   userId: localStorage.getItem("user_id"),

            // need userId to send data to firebase
            userId: sessionStorage.getItem('MyID'),
            team1Name: this.state.team1Name,
            team1LogoName: this.state.team1LogoName,
            team1LogoURL: this.state.team1LogoURL || ''
          };
         
         
         
          generateTeamData(data).then((response) => {
            axios.get('http://localhost:5000/refresh')
              .then(function (response) {
                // handle success
                // console.log("Updated Sucessfullyyyyyyyyyyyyyyyyy");
              })
              .catch(function (error) {
                // handle error
                console.log(error);
              })
              .finally(function () {
                // always executed
              });
            this.setState({
              dataResponse: response
            })
            setTimeout(() => {
              window.location.href = "/teamsScreen"
            }, 100);
          })
            .catch(err => {
              console.log(err);
            });
          this.setState({
            
            team1Name: '',
            team1Logo: '',
          });

        }
    } catch (err) {
      console.log("error at handleToggle in generatingData");
    }
  };



  RedirectUser = () => {
    this.props.history.push("/eventScreen");
  };

  /********************************************************************************************************************************** */


  getInfoFromAssests = () => {


    // componentDidMount() {




    getAssetsInfo()
      .then((response) => {
        // console.log("response", response);
        this.setState({

          team1LogoURL: response[0].teamLogoURL,
          team1LogoName: response[0].teamLogoName,
          team1Name: response[0].teamName,
          team1Logo: response[0].teamLogoURL,
          team1Hex1: response[0].teamHex1,
          team1Hex2: response[0].teamHex2,



        });
        document.querySelector('input[id=TeamHex1').value = this.state.team1Hex1;
        document.querySelector('input[id=TeamHex2').value = this.state.team1Hex2;
        // console.log("fetchEvent", this.state.newData);
      })
      .catch((error) => {
        console.log(error);
      });
    // }


  }



  /*********************************************************************************************************************************** */

  slideCards = () => {
    try {
      this.setState({ slideCards: !this.state.slideCards });
    } catch (err) {
      console.log("error at slideCards in dashBoard");
    }
  };
  /**
   * @description:it handles the cards style
   */
  handleCardStyle = () => {
    try {
      this.setState({ cardStyles: !this.state.cardStyles });
    } catch (err) {
      console.log("error at handleCardStyle in dashBoard");
    }
  }

  /****************************************************************************************************************************** */




  //  Comp() {
  // The first commit of Material-UI


  // const classes = useStyles();

  // handleDateChange(date) {
  //   setSelectedDate(date);
  // }

  /******************************************************************************************************************************* */
  render() {

    const { date } = this.state


    const { classes } = this.props;

    // const classes = useStyles();
    // const { classes } = this.props;
    const slidingCards = this.state.slideCards ? "afterSlide" : "beforeSlide";





    return (
      <MuiThemeProvider theme={theme} location={this.props.location}>

        <div className={classes.root}>

          <div className={slidingCards} id={slidingCards}>

            <div style={{ position: 'relative', }}>
              <TopBar
                slideCards={this.slideCards}
                props={this.props}
                notePropsToApp={this.handleCardStyle}
                handleNavigation={this.handleNavigation}
              />
            </div>
          </div>



          {this.state.loading ? <div class="datagenerate">
            <div
              style={{
                textAlign: "center",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                top: "45vh",
                left: "35vw"
              }}
            >
              <Loader type="Circles" color="#422963" height="100%" width="100px" />
            </div>
          </div> :
            <div class="datagenerate" >
              <form onSubmit={this.handleToggle}>
                


             
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <h4 style={{ marginTop: 10, textDecorationLine: 'underline', fontWeight: ' bold' }}>Team Information :</h4>
                </div>

                <section class="sectionClass">

                  <div class="container-fluid">
                    <div class="row sectRow">

                      <div class="col-md-4 col-sm-6">

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}>Team Name: <span className="red">*</span>  </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold', }}>Team Logo: <span className="red">*</span>  </label>
                        </div>

                      </div>


                      <div class="col-md-8 col-sm-6">

                        <div className='labelDivRight' >
                          <Input
                            // disableUnderline={true}
                            style={{}}
                            value={this.state.team1Name}
                            onChange={this.handleteam1Name}
                            required
                          />
                        </div>


                        <div className='labelDivRight' >
                          <label for="team1" className="MyButton" style={{ marginBottom: '0' }} onMouseLeave={this.getName}>Upload Image</label>
                          {!this.state.image3Checked ? null :
                            <div>
                              <label className="setMyPadding" required>{this.state.team1LogoName}</label>
                              {this.state.team1LogoName ? <FaTrash onClick={this.removeAsset} /> : null}
                            </div>}
                          <input id="team1" style={{ visibility: 'hidden' }} type="file" accept=".jpg, .jpeg, .png" required></input>
                          {/* <input type='file' id="team1" style={{ outline: 'none' ,margin:'5px' }} />
                    <img src={this.state.team1LogoURL} width="50" height="50" alt="teamLogo" /> */}
                        </div>
                        {this.state.image3Checked ? null :
                          <div className="labelDivRight">
                            <span className="red">{this.state.image3Message}</span>
                          </div>}

                        
                      </div>
                    </div>
                  </div>

                </section>

                {/* <div style={{ display: 'flex', flexDirection: 'row', }}>
                  <div className="LogoClass">
                    <p style={{ fontWeight: 'bold', marginLeft: '-50px' }}>Team 2 Logo :
                     <input type='file' id="team2" style={{ outline: 'none', paddingLeft: '70px' }} />
                      <img src={this.state.team2LogoURL} width="50" height="50" alt="teamLogo" />
                    </p>
                  </div>
                </div> */}


                {/*******************************************TEAM 2************************************************************************* */}

                <section class="sectionClass">

                  <div class="container-fluid">
                    <div class="row sectRow">

                      <div class="col-md-4 col-sm-6">
                        {/*
                     <div className='labelDivLeft' >
                      <label style={{ fontWeight: 'bold' }}>Team 2 Name: </label>
                    </div> */}

                        {/* <div className='labelDivLeft' >
                      <label style={{ fontWeight: 'bold', }}>Team 2 Logo : </label>
                    </div>

                    <div className='labelDivLeft' >
                      <label style={{ fontWeight: 'bold' }}>Team 2 Primary Color Hex: </label>
                    </div>

                    <div className='labelDivLeft' >
                      <label style={{ fontWeight: 'bold' }} >Team 2 Secondary Color Hex: </label>
                    </div> */}


                      </div>


                      <div class="col-md-8 col-sm-6">

                        {/* <div className='labelDivRight' >
                      <Input
                        // disableUnderline={true}
                        style={{}}
                        value={this.state.team2Name}
                        onChange={this.handleteam2Name}
                      />
                    </div> */}


                        {/* <div className='labelDivRight' style={{ display: 'flex', flexDirection: 'row' }}>
                      <label for="team2" className="MyButton" onMouseLeave={this.getName}>Upload Image</label>
                      <label className="setMyPadding">{this.state.team2LogoName}</label>
                      {this.state.team2LogoName ? <FaTrash onClick={this.removeMe} /> : null}
                      <input id="team2" style={{ visibility: 'hidden' }} type="file"></input>

                      {/*
                      <input type='file' id="team2" style={{ outline: 'none' ,margin:'5px' }} />
                      <img src={this.state.team2LogoURL} width="50" height="50" alt="teamLogo" />
                    </div>

                    <div className='labelDivRight' >
                        <input id="Team2Hex1" className="jscolor ColorPickerStyle" onBlur={this.handleteam2Hex1}></input>
                    </div>


                    <div className='labelDivRight'>
                      <input id="Team2Hex2" className="jscolor ColorPickerStyle" onBlur={this.handleteam2Hex2}></input>
                  </div> */}

                      </div>


                    </div>
                  </div>

                </section>

                {/******************************************************************************************************************************* */}

                <div>
                  <Button
                    // id="CloseButtonNote"
                    id="button12"
                    className="ButtonStyle"
                    type="submit"
                  // style={{ backgroundColor: "transparent" }}
                  //disabled={!this.state.checkDisabled}
                  >
                    Save
                  </Button>
                </div>
              </form>
            </div>

          }


        </div>
      </MuiThemeProvider>
    )
  }

}



export default withStyles({ withTheme: true })(dataGenerate);